import { gql, useMutation } from "@apollo/client";

export type RecoverPasswordInput = {
    email: string;
};

const RECOVER_PASSWORD = gql(`
mutation UserRecoverPassword($input: GqlUserRecoverPasswordInput!) {
  userRecoverPassword(input: $input)
}
    `);

export default function useRecoverPassword() {
    const [recoverPassword, { data, loading, error }] = useMutation(RECOVER_PASSWORD);

    return {
        recoverPassword: (data: RecoverPasswordInput) =>
            recoverPassword({
                variables: {
                    input: data,
                },
            }),
        loading,
        error,
        data: data?.userRecoverPassword,
    };
}
